// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"16637bc3","787":"4eb5b363"}[chunkId] + ".chunk.js";
};